<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.merchant-list-page {
  height: 100vh;
  padding-top: 140px;
  overflow: scroll;
  // background-image: url('https://oss.turingsenseai.com/1623912866964426136.png');
  background-size: 100% 100%;
  background-color: #F8F8FB;

  .search-container {
    // background-image: url('https://oss.turingsenseai.com/1623913475552458502.png');
    background-color: #fff;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    height: 120px;
    width: 100%;
    z-index: 999;
    .input-wrap {
      width: 702px;
      height: 72px;
      box-sizing: border-box;
      // border: 4px solid #000;
      border-radius: 4px;
      background-color: #F8F8FB;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      margin: 24px auto;
      .search-input {
        flex: 1;
        margin-right: 20px;
        border: none;
        height: 64px;
        padding-left: 24px;
        background-color: #f8f8fb;
      }
      .search-icon {
        width: 36px;
        height: 36px;
        object-fit: contain;
      }
    }

  }

  .split-line {
    position: fixed;
    top: 120px;
    height: 18px;
    width: 100%;
    background-image: url('https://oss.turingsenseai.com/1623914645893707324.png');
    background-size: 100% 100%;
    z-index: 999;
  }

  .merchant-list {
    margin: 0 auto;
    width: 702px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .merchant-item {
      margin-bottom: 18px;
      width: 344px;
      height: 322px;
      box-sizing: border-box;
      // border: 4px solid #000;
      border-radius: 4px;
      background-color: #fff;
      .avator {
        width: 128px;
        height: 128px;
        // border: 3px solid #000;
        overflow: hidden;
        margin: 36px auto 0;
        border-radius: 50%;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover
        }
      }
      .nickname {
        margin-top: 24px;
        text-align: center;
        font-size: 28px;
        color: #000;
        font-weight: 300;
        line-height: 36px;
      }
      .msg-container {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .count-item-l, .count-item-r {
          display: flex;
          justify-content: center;
          align-items: center;
          .label {
            font-size: 26px;
            color: #828393;
            margin-right: 8px;
          }
          .count {
            color: #5757FF;
            font-size: 26px;
            font-weight: 700;
          }
        }
        .count-item-l {
          margin-right: 26px;
        }
      }
    }
  }
  .no-data-container {
    padding-top: 312px;
    text-align: center;
    width: 100%;
    .tips {
      font-size: 28px;
      // width: 100%;
      color: #2a2a30;
      text-align: center;
    }
  }
}
</style>

<template>
<div class="merchant-list-page">
  <van-empty v-if="!isSupport" image="error" description="非常抱歉，暂不支持此APP扫码" />
  <div v-if="isSupport">
    <div class="search-container">
      <div class="input-wrap">
        <input type="text" placeholder="搜索展位" class="search-input" v-model="searchWords"/>
        <img class="search-icon" @click="getMerchantList(true)" src="https://oss.turingsenseai.com/1623826683071669972.png"/>
      </div>
    </div>
    <!-- <div class="split-line">
    </div> -->
    <van-pull-refresh v-if="dataList.length > 0" v-model="refreshing" @refresh="getMerchantList(true)">
      <van-list
        v-model="loadingMore"
        :finished="finished"
        finished-text="没有更多了"
        @load="getMerchantList(false)">
        <div class="merchant-list">
          <div class="merchant-item" v-for="(merchant, index) in dataList" :key="index" @click="goDetail(merchant.uid)">
            <div class="avator">
              <img class="img" :src="merchant.avatar" alt="">
            </div>
            <div class="nickname">{{merchant.nickName || '—'}}</div>
            <div class="msg-container">
              <div v-if="merchant.onSaleNum > 0" class="count-item-l">
                <div class="label">在售</div>
                <div class="count">{{merchant.onSaleNum}}</div>
              </div>
              
              <div v-if="merchant.soldNum > 0" class="count-item-r">
                <div class="label">已售</div>
                <div class="count">{{merchant.soldNum}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-else class="no-data-container">
      <div class="tips">暂无数据</div>
    </div>
    <cart-float/>
  </div>
</div>
  
</template>

<script>
import { List, PullRefresh, Popup, Toast } from 'vant';
// import { fetchMerchantList } from '../../../common/api/bag-show'
import { fetchMerchantList } from '../../../common/api/purchase'
import  CartFloat from './../components/cart.vue'

export default {
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-popup': Popup,
    'cart-float': CartFloat,
  },
  data() {
    return {
      isSupport:true,  //扫码进入的路径是否支持
      loadingMore: false,
      finished: false,
      refreshing: false,
      pageNum: 0,
      pageSize: 20,
      searchWords: '',
      dataList: [],
      loading: false,
    }
  },
  created() {
    let userAgent=window.navigator.userAgent
    if(userAgent.indexOf('QQ')>0 ||  //QQ
      userAgent.indexOf('AlipayClient')>0          //支付宝             
    ){
      this.isSupport=false
    }else{
      this.getMerchantList(true)
    }
  },
  methods: {
    getMerchantList(reset) {
      if (reset) {
        this.pageNum = 0
        this.finished = false;
      }
      if (this.finished || this.loading) return
      this.pageNum ++ 
      this.loading = true
      fetchMerchantList({ pageNum: this.pageNum, pageSize: this.pageSize, merchantName: this.searchWords })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.dataList = reset ? res.merchantList : [...this.dataList, ...res.merchantList]
            this.finished = res.isEnd
          }
        }).finally(() => {
          this.refreshing = false;
          this.loadingMore = false;
          this.loading = false
        })
    },
    search() {

    },
    goDetail(merchantId) {
      this.$router.push({ path: `/purchase/product-list/${merchantId}`})
    }
  }
}
</script>